import api from "../../../api/axios";

const root = (companyId) => `/companies/${companyId}/imports/clients`;

function appendImportFields(body, {
  file,
  sheet,
  mapping,
  valueMappings,
  responsibleMapping,
  sourceNamespace,
}) {
  body.append("file", file);
  if (sheet) body.append("sheet", sheet);
  body.append("mapping", JSON.stringify(mapping || {}));
  body.append("value_mappings", JSON.stringify(valueMappings || {}));
  body.append(
    "responsible_user_mapping",
    JSON.stringify(responsibleMapping || {}),
  );
  body.append("source_namespace", sourceNamespace || "");
}

export function inspectClientImport(companyId, { file, sheet }) {
  const body = new FormData();
  body.append("file", file);
  if (sheet) body.append("sheet", sheet);
  return api
    .post(`${root(companyId)}/inspect/`, body)
    .then((res) => res.data);
}

export function previewClientImport(
  companyId,
  { file, sheet, mapping, valueMappings, responsibleMapping, sourceNamespace },
) {
  const body = new FormData();
  appendImportFields(body, {
    file,
    sheet,
    mapping,
    valueMappings,
    responsibleMapping,
    sourceNamespace,
  });
  return api
    .post(`${root(companyId)}/preview/`, body)
    .then((res) => res.data);
}

export function commitClientImport(
  companyId,
  {
    file,
    sheet,
    mapping,
    valueMappings,
    responsibleMapping,
    sourceNamespace,
    idempotencyKey,
  },
) {
  const body = new FormData();
  appendImportFields(body, {
    file,
    sheet,
    mapping,
    valueMappings,
    responsibleMapping,
    sourceNamespace,
  });
  return api
    .post(`${root(companyId)}/commit/`, body, {
      headers: { "Idempotency-Key": idempotencyKey },
    })
    .then((res) => res.data);
}

export function fetchClientImportOperation(companyId, operationId) {
  return api
    .get(`${root(companyId)}/operations/${operationId}/`)
    .then((res) => res.data);
}

export function fetchClientImportOperationRows(companyId, operationId, params) {
  return api
    .get(`${root(companyId)}/operations/${operationId}/rows/`, { params })
    .then((res) => res.data);
}
